<template lang="pug">
  v-flex(xs12 md4)
    v-layout(row wrap)
      v-flex(xs12)
        div.headline.pb-5 Write the Instructions
      v-flex(xs12)
        v-textarea(
          label="Insert the task instructions here"
          v-model="textInstructions"
          rows=20
          box
          no-resize
        )
</template>
<script>

export default {
  data() {
    return {
      textInstructions: this.value,
    };
  },
  props: {
    /**
     * The task instructions
     */
    value: {
      type: String,
    },
  },
  watch: {
    textInstructions(value) {
      this.$emit('input', this.textInstructions);
    },
  },
};
</script>
